<template>
  <div id="play">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('index.videos') }}
      </div>
    </div>
    <video
      id="my-video"
      class="video-js vjs-default-skin"
      controls
      preload="auto"
      style="width:100%;height: 250px;"
    >
      <source :src="data.url">
    </video>
  </div>
</template>

<script>
	import Vue from 'vue';
	import Fetch from '../../utils/fetch';
	import Api from "../../interface/index"

import { NoticeBar } from 'vant';
Vue.use(NoticeBar);
	import {
		Swipe,
		SwipeItem,
		Icon,
		Progress,
		Dialog,
		Field
	} from "vant";

	Vue.use(Icon).use(Progress).use(Dialog).use(Field);

	export default {
		name: "Video",
		components: {
			VanSwipe: Swipe,
			VanSwipeItem: SwipeItem,
		},
		data() {
			return {
				lang:this.$i18n.locale||"zh_cn",
				data: {url:'https://www.fspy888.live/static/mp3/video.mp4'},
			};
		}
	};
</script>
<style lang="less" scoped>
    .red_top_bg{
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        z-index: 10;
    }
	
	.wrap_box{
		
		margin-top: 12px;
		display: flex;
		flex-direction: column;
		align-items: center;
		.item{
			height: 50px;
			width: 95%;
			padding: 16px 0;
			border-bottom: 1px solid #ececec;
			font-size: 14px;
			color: rgba(0,0,0,.8);
			font-weight: 700;
			line-height: 20px;
			display: flex;
			justify-content: space-between;
		}
	}

	/* Standalone player follows the product catalog's light teal surface. */
	#play { min-height: 100vh; padding-top: 50px; background: linear-gradient(180deg, #f8fcfb 0%, #edf7f5 100%); }
	.red_top_bg { height: 50px; background: rgba(255, 255, 255, .97); border-bottom: 1px solid #b9dcd8; box-shadow: 0 4px 14px rgba(7, 72, 78, .06); }
	.red_top_bg .big_tit { display: flex; height: 50px; align-items: center; justify-content: center; color: #073f47; font-size: 16px; font-weight: 600; }
	.red_top_bg .back_left { top: 13px; display: flex; width: 24px; height: 24px; align-items: center; justify-content: center; box-sizing: border-box; border: 1px solid #b9dcd8; border-radius: 50%; background: #eaf6f4; color: #073f47; box-shadow: 0 3px 8px rgba(7, 72, 78, .08); }
	.red_top_bg .back_left::after { width: 8px; height: 8px; margin-left: 3px; border-bottom: 2px solid #073f47; border-left: 2px solid #073f47; content: ''; transform: rotate(45deg); }
	#my-video { display: block; height: auto !important; min-height: 220px; margin: 16px 14px; width: calc(100% - 28px) !important; border: 1px solid #b9dcd8; border-radius: 13px; background: #082d33; box-shadow: 0 10px 20px rgba(7, 72, 78, .12); }
</style>
